import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { AdminApiTokenRevealComponent } from "./admin-api-token-reveal.component";

@NgModule({
  declarations: [AdminApiTokenRevealComponent],
  imports: [CommonModule, TranslateModule, NzAlertModule, NzButtonModule, NzIconModule, NzInputModule, ClipboardModule],
})
export class AdminApiTokenRevealModule {}
